import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';
import type { TripParticipation } from '../../functions/src/travellerRoutePolicy.mjs';

export type MembershipAction = 'accept' | 'decline' | 'leave';

/** Accept, decline or leave through the server, which changes only this user's entry. */
export async function respondToTrip(tripId: string, action: MembershipAction, inviteNotificationId?: string, participation?: TripParticipation | null): Promise<'done' | 'unchanged' | 'gone'> {
  const call = httpsCallable<{ tripId: string; action: MembershipAction; inviteNotificationId?: string; participation?: TripParticipation | null }, { outcome: 'done' | 'unchanged' | 'gone' }>(functions, 'respondToTrip');
  return (await call({ tripId, action, ...(inviteNotificationId ? { inviteNotificationId } : {}), ...(participation !== undefined ? { participation } : {}) })).data.outcome;
}

export async function changeTripParticipation(tripId: string, userId: string, before: TripParticipation | null, participation: TripParticipation | null) {
  const call = httpsCallable<{ tripId: string; userId: string; before: TripParticipation | null; participation: TripParticipation | null }, { participation: TripParticipation | null }>(functions, 'changeTripParticipation');
  return (await call({ tripId, userId, before, participation })).data.participation;
}
